import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { LearningPathModel } from '../models/learning-path.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';

@Injectable({
  providedIn: 'root',
})

export class LearningPathService extends BaseFucntionsService<LearningPathModel> {
  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.LearningPath.LearningPaths, apiClient);
  }

  getDetails(learningPathId: number) {
    return this.apiClient.get(`${ApplicationRoutes.LearningPath.LearningPathDetail(learningPathId)}`);
  }

  getStudentLearningPath(isDiploma: boolean) {
    return this.apiClient.get(`${ApplicationRoutes.LearningPath.StudentLearningPath}?isDiploma=${isDiploma}`);
  }
}
